import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";

const AddEditPackage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddUser = location.pathname === "/manage-packages/add";

  const [features, setFeatures] = useState<string[]>([""]);

  const handleFeatureChange = (index: number, value: string) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };

  const addFeature = () => {
    setFeatures([...features, ""]);
  };

  const removeFeature = (index: number) => {
    const updated = features.filter((_, i) => i !== index);
    setFeatures(updated);
  };

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>{isAddUser ? "Add" : "Edit"} Package</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-packages")}>
            Manage Packages
          </button>{" "}
          - {isAddUser ? "Add" : "Edit"} Package
        </p>
      </div>

      <div className="form">
        <div className="cards">
          <div className="gap_p">

            {/* Best Value */}
            <div className="control_group flex w_100">
              <label>Is this Best Value?</label>
              <SwitchToggle />
            </div>

            {/* Package Name */}
            <div className="control_group w_50">
              <label>Package Name</label>
              <TextField placeholder="Enter Package Name" hiddenLabel fullWidth />
            </div>

            {/* Package Price */}
            <div className="control_group w_33">
              <label>Price Per Month</label>
              <TextField
                type="number"
                placeholder="Enter Price"
                hiddenLabel
                fullWidth
              />
            </div>

            {/* Features */}
            <div className="control_group w_50">
              <label>Features</label>

              <div className="feature_list">
                {features.map((feature, index) => (
                  <div key={index} className="feature_item">
                    <TextField
                      placeholder={`Feature ${index + 1}`}
                      value={feature}
                      onChange={(e) =>
                        handleFeatureChange(index, e.target.value)
                      }
                      hiddenLabel
                      fullWidth
                    />

                    {features.length > 1 && (
                      <IconButton className="btn_rounded red" onClick={() => removeFeature(index)}>
                        <CloseIcon />
                      </IconButton>
                    )}
                  </div>
                ))}

                <Button className="btn btn_primary sm" onClick={addFeature}><AddIcon /> Add Feature</Button>
              </div>

            </div>
          </div>
        </div>

        {/* SAVE BUTTON */}
        <div className="form_btn">
          <Button className="btn btn_primary">Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddEditPackage;
